import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { PointGeoJSON } from '@fc-locations/models/geojson';
import { Vehicle, VehicleType } from '@fc-core';
import { VehicleOptions } from '@fc-core/models/vehicle/vehicle-options';
import { VehicleAttachmentModel } from '@fc-vehicles/models/vehicle-attachment-model';

export const setLoaded = createAction('[CoreVehicle/API] Set Loaded');

export const loadUsedVehicleTypes = createAction(
  '[CoreVehicle/API] Load Used Vehicle Types',
);

export const loadUsedVehicleTypesSuccess = createAction(
  '[CoreVehicle/API] Load Used Vehicle Types Success',
  props<{ vehicleTypes: VehicleType[] }>(),
);
export const loadVehicleTypes = createAction(
  '[CoreVehicle/API] Load Vehicle Types',
);
export const loadVehicleTypesSuccess = createAction(
  '[CoreVehicle/API] Load Vehicle Types Success',
  props<{ vehicleTypes: VehicleType[] }>(),
);

export const loadVehicles = createAction(
  '[CoreVehicle/API] Load Vehicles',
  props<{ options?: VehicleOptions[]; map?: boolean }>(),
);

export const loadVehiclesSuccess = createAction(
  '[CoreVehicle/API] Load Vehicles Success',
  props<{
    vehicles: Vehicle[];
    count: number;
    fields?: string[];
    totalLoaded: number;
  }>(),
);
export const cancelLoadVehicles = createAction(
  '[CoreVehicle/API] Cancel Load Vehicles',
);

export const reloadVehicles = createAction('[CoreVehicle/API] ReLoad Vehicles');

export const selectVehicleId = createAction(
  '[CoreVehicle] Select Vehicle Id',
  props<{ vehicleId: number | null }>(),
);

export const vehiclesError = createAction(
  '[CoreVehicle/API] Vehicles Error',
  props<{ error: any }>(),
);
export const updateVehicles = createAction(
  '[CoreVehicle/API] Update Vehicles',
  props<{
    vehicles: Vehicle[];
    count: number;
    fields: string[];
    totalLoaded: number;
  }>(),
);

export const eventSourceVehicleUpdates = createAction(
  '[CoreVehicle/API] EventSource Vehicles Updates',
  props<{ vehicles: Update<Vehicle>[] }>(),
);
export const addVehicle = createAction(
  '[CoreVehicle/API] Add Vehicle',
  props<{ vehicle: Vehicle }>(),
);
export const addVehicleSuccess = createAction(
  '[CoreVehicle/API] Add Vehicle Success',
  props<{ vehicle: Vehicle }>(),
);

export const deleteVehicle = createAction(
  '[CoreVehicle/API] Delete Vehicle',
  props<{ id: number }>(),
);

export const deleteVehicleSuccess = createAction(
  '[CoreVehicle/API] Delete Vehicle Success',
  props<{ id: number }>(),
);
export const updateVehicle = createAction(
  '[Vehicle/API] Update Vehicle',
  props<{ vehicle: Vehicle; fields: string[] }>(),
);
export const updateVehicleSuccess = createAction(
  '[Vehicle/API] Update Vehicle Success',
  props<{ vehicle: Update<Vehicle> }>(),
);
export const updateVehicleMainPhoto = createAction(
  '[Vehicle/API] Update Vehicle Main Photo',
  props<{ vehicleId: number; photo: VehicleAttachmentModel }>(),
);

export const loadVehicleData = createAction(
  '[CoreVehicle/API] Load Vehicle Data',
  props<{ vehicleId: number; options?: string[] }>(),
);

export const setVehicleLocation = createAction(
  '[CoreVehicle/API] Set Vehicle Location',
  props<{ vehicleId: number; point: PointGeoJSON; locationId?: number }>(),
);

export const setVehicleLocationSuccess = createAction(
  '[CoreVehicle/API] Set Vehicle Location Success',
  props<{ vehicleId: number; point: PointGeoJSON; locationId?: number }>(),
);
